module.exports = __webpack_public_path__ + "img/slovenskodigital-logo.31f889ad.svg";